import React from 'react';
import { ConfirmCancelButtons, Logo } from '@plerionhq/design-system';
import { useLocation, useNavigate } from 'react-router-dom';

import { useTranslation } from 'react-i18next';

interface EnvironmentPanelProps {
  onDismiss: () => void;
}

export const EnvironmentSuggestionPanel = ({
  onDismiss,
}: EnvironmentPanelProps) => {
  const { t } = useTranslation('containerInterface');
  const { pathname } = useLocation();
  const navigate = useNavigate();

  return (
    <div
      className={`${pathname.startsWith('/admin/') ? 'm-4' : 'mx-4 mt-4'} border-container-border rounded-panel flex items-center justify-between gap-4 border bg-white p-4 dark:bg-gray-800`}
    >
      <div className="flex flex-row items-center">
        <Logo name="Plerion" />
        <div className="pl-4">
          <div className="text-action-primary text-lg font-semibold">
            {t('configureYourEnvironment')}
          </div>
          <div>{t('quicklyPrioritizeYourSecurityIssuesByUsing')}</div>
        </div>
      </div>
      <ConfirmCancelButtons
        cancelLabel={t('dismiss')}
        confirmLabel={t('configureEnvironments')}
        onCancel={onDismiss}
        onConfirm={() => navigate('/environments')}
      />
    </div>
  );
};
